// The svg carries text-neutral-900 (#171717 in light mode, remapped in dark)
// so the default currentColor stroke follows the theme; explicit strokeColor
// props still win because they set the stroke attribute directly.
export default function LoadingSpinner({
  height = 40,
  width = 40,
  strokeColor = 'currentColor',
  className = '',
  isDarkMode = false,
}) {
  return (
    <div className={`loader overflow-hidden ${className ? ` ${className}` : ''}`} data-testid="loadingSpinner">
      <svg viewBox="0 0 32 32" width={width} height={height} className="spinner-svg text-neutral-900">
        <circle
          id="spinner"
          cx="16"
          cy="16"
          r="14"
          stroke={isDarkMode ? '#fff' : strokeColor}
          fill="none"
          className="spinner"
        ></circle>
      </svg>
    </div>
  );
}
